import Popup from './Popup';
import "../css/Viewpage.css";
import '../css/Nav design.css';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import ProfileDetailsRespone from '../model/response/ProfileDetailsRespone';
import { useState, useEffect } from "react";
import logo from '../images/logo.jpeg';
import shortlist from '../images/shortlist.png';
import notShortlist from '../images/nonshortlist.png';
import { Oval } from "react-loader-spinner";
import default_avatar from '../images/default_avatar.png';
import Notification from './Notification';
import Report from "./Report";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import PopupBlock from "./popup_block";
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useSearchParams } from "react-router-dom";



function Customerdetails() {

  console.log("Customerdetails Render");
  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;

  const gender = localStorage.getItem("gender");

  const isAstrologyPaid =
    loginVal?.isPaidForAstrology === true ||
    loginVal?.IsPaidForAstrology === true;

  console.log("🔥 Login User Astrology Paid:", isAstrologyPaid);

  var location = useLocation();

  const userId = location.state?.userId;
  const is_Paid = location.state?.is_Paid;
  const isPaid = location.state?.isPaid;
  const opponentId = location.state?.opponentId;
  console.log(userId);
  console.log(opponentId);

  const savedImage = localStorage.getItem("image")

  const token = localStorage.getItem('token');
  const [profile, SetProfile] = useState({});
  const [isLoading, setIsLoading] = useState(false)
  const [users, setUsers] = useState([]);
  const [activeUser, setActiveUser] = useState([]);
  const [showNotif, setShowNotif] = useState(false);
  const [showsubMenu, setShowsubMenu] = useState(false);

  const [showMenu, setShowMenu] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openReport, setOpenReport] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [viewedMobile, setViewedMobile] = useState("");
  const [isPaidUser, setIsPaidUser] = useState(
    JSON.parse(localStorage.getItem("loginVal"))?.is_Paid || false
  );

  const [requestedFields, setRequestedFields] = useState({});
  const [searchParams] = useSearchParams();

  const [chartData, setChartData] = useState(null);
  const [isAstrologyPaidcheck, setIsAstrologyPaidcheck] = useState(
    localStorage.getItem("isPaidForAstrology") === "true"
  );

  console.log(
    "Astrology Paid:",
    localStorage.getItem("isPaidForAstrology")
  );
  const loggedInUserMotherTongue =
    loginVal?.mother_Tongue || "";

  const language = loggedInUserMotherTongue.toLowerCase();

  console.log("LOGIN USER MOTHER TONGUE:", language);

  console.log("LOGIN VAL:", loginVal);
  console.log("IS PAID ASTROLOGY:", loginVal?.isPaidForAstrology);
  console.log("IS PAID ASTROLOGY CAPS:", loginVal?.IsPaidForAstrology);

  const languageFieldMap = {
    tamil: "name_ta",
    hindi: "name_hi",
    telugu: "name_te",
    malayalam: "name_ml",
    kannada: "name_kn",
    english: "name_en",
  };

  const languageField = languageFieldMap[language] || "name_en";

  const getLanguageName = (data) => {
    if (!data) return "-";

    const field = languageFieldMap[language];

    const localName = data?.[field];
    const englishName = data?.name_en;

    if (language === "english") {
      return englishName || data?.name || "-";
    }

    if (localName && englishName) {
      return `${localName} (${englishName})`;
    }

    return localName || englishName || data?.name || "-";
  };
  const navigation = useNavigate()
  function clickEditprofile() {
    navigation('/Editprofile')
  }
  function click(type) {
    setShowPopup(false);
    if (type) {
      blockUserAPICall(userId);
    }
  }
  function clickUpgradeplans() {
    navigation('/Upgrade')
  }
  function clickSettingspage() {
    navigation('/settingspage')
  }
  function clicktoUpgradePage() {
    navigation('/Upgrade', { state: { fromUserId: userId, isPaid: isPaid, is_Paid: is_Paid } })
  }


  const rasiList = [
    { id: 11, name: "Meena" },
    { id: 0, name: "Mesha" },
    { id: 1, name: "Vrishabha" },
    { id: 2, name: "Mithuna" },
    { id: 10, name: "Kumbha" },
    { id: "center", name: "CENTER" },
    { id: 3, name: "Karkataka" },
    { id: 9, name: "Makara" },
    { id: 4, name: "Simha" },
    { id: 5, name: "Kanya" },
    { id: 6, name: "Tula" },
    { id: 7, name: "Vrischika" },
    { id: 8, name: "Dhanu" }
  ];


  function clickLogin() {
    localStorage.clear();
    localStorage.removeItem('loginVal');
    localStorage.removeItem('token');
    logoutAPICall();
    navigation('/login')
  }

  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  useEffect(() => {

    getProfileAPICall();
    saveViewedListAPICall();


  }, [userId]);


  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  function getProfileAPICall() {

    var obj = { user_Id: userId, login_user_id: loginVal.user_Id }
    console.log("Response:", JSON.stringify(obj));
    axios.post(
      ApiConfig.getUrl("User/getUsersProfile"),
      JSON.stringify(obj),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` // Standard Bearer format
        }
      }
    )
      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        if (api.statusCode == 200) {

          const profileVal = ProfileDetailsRespone.fromJson(api.response);

          SetProfile(profileVal);

          // generateBirthChart();
          // showToast(api.message);
        } else {
          showToastFailed(api.errorMessage);
        }

      })
      .catch(error => {

        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("loginVal");

          navigation("/login");
          return;
        }

        showToastFailed(error);
        console.error("Error:", error);
      });
  }

  // const checkAstrologyLimit = async () => {
  //   try {
  //     const response = await axios.post(
  //       ApiConfig.getUrl("api/Astrology/Astrology_limit"),
  //       {
  //         userId: Number(loginVal.user_Id),
  //         opponentUserId: Number(userId)
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`
  //         }
  //       }
  //     );

  //     console.log("Astrology Limit Response:", response.data);

  //     const api = ApiResponse.fromJson(response.data);

  //     return api;

  //   } catch (error) {
  //     console.error("Astrology Limit Error:", error);

  //     throw error;
  //   }
  // };

  const checkLimitAndGenerateChart = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        ApiConfig.getUrl("api/Astrology/Astrology_limit"),
        {
          userId: Number(loginVal.user_Id),
          opponentUserId: Number(userId)
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("🔥 Astrology Limit Response:", response.data);

      const api = ApiResponse.fromJson(response.data);

      const limitResponse = api.response;

      console.log("Has Access:", limitResponse?.hasAccess);
      console.log("Remaining Views:", limitResponse?.remainingViews);
      console.log("Limit Message:", limitResponse?.message);

      // Access available
      if (
        api.statusCode === 200 &&
        api.status === true &&
        limitResponse?.hasAccess === true
      ) {
        console.log(
          "✅ Access Granted. Remaining Views:",
          limitResponse.remainingViews
        );

        // Birth chart generate
        generateBirthChart();

        return;
      }

      // Limit exceeded
      console.log("❌ Astrology limit exceeded");

      localStorage.setItem("isPaidForAstrology", "false");

      setIsAstrologyPaidcheck(false);
      setChartData(null);

      showToastFailed(
        limitResponse?.message ||
        api.message ||
        "Your astrology view limit has been reached. Please pay again."
      );

    } catch (error) {
      console.error("❌ Astrology Limit API Error:", error);

      const errorData = error?.response?.data;

      showToastFailed(
        errorData?.response?.message ||
        errorData?.message ||
        "Unable to check astrology limit."
      );

    } finally {
      setIsLoading(false);
    }
  };


  function generateBirthChart() {
    console.log(
      "🔥 generateBirthChart CALLED",
      new Date().toISOString()
    );

    const loginUserId = Number(loginVal?.user_Id);
    const profileUserId = Number(userId);

    console.log("👤 Login User ID:", loginUserId);
    console.log("👤 Profile/Opponent ID:", profileUserId);

    if (!loginUserId || !profileUserId) {
      console.error("❌ User IDs missing");
      showToastFailed("User details missing.");
      return;
    }

    axios
      .post(
        `${ApiConfig.getUrl(
          "api/Astrology/generateBirthChart"
        )}/${profileUserId}`,
        {
          opponentId: loginUserId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then((response) => {
        console.log(
          "🔥 Birth Chart API Response:",
          response.data
        );

        const api = ApiResponse.fromJson(response.data);

        if (api.statusCode === 200 && api.status === true) {
          console.log(
            "✅ Birth chart response:",
            api.response
          );

          console.log(
            "🔥 FULL CHART RESPONSE:",
            JSON.stringify(api.response, null, 2)
          );

          console.log("RAASI:", api.response?.raasi_En);
          console.log("STAR:", api.response?.star_En);
          console.log("LAGNA:", api.response?.lagna_En);

          // ============================================
          // HELPER - STRING JSON -> OBJECT
          // ============================================

          const parseJsonDetails = (value, fieldName) => {
            if (!value) {
              return null;
            }

            try {
              const parsed =
                typeof value === "string"
                  ? JSON.parse(value)
                  : value;

              console.log(
                `✅ Parsed ${fieldName}:`,
                parsed
              );

              return parsed;
            } catch (error) {
              console.error(
                `❌ ${fieldName} JSON Parse Error:`,
                error
              );

              return null;
            }
          };

          // ============================================
          // PLANET POSITION
          // ============================================

          const planetPosition = parseJsonDetails(
            api.response?.planet_Position,
            "Planet Position"
          );

          console.log(
            "🌍 Parsed Planet Position:",
            planetPosition
          );

          console.log(
            "🪐 Planet List:",
            planetPosition?.data?.planet_position
          );

          // ============================================
          // MANGLIK DETAILS
          // ============================================

          const manglikDetails = parseJsonDetails(
            api.response?.manglik_Details,
            "Manglik Details"
          );

          console.log(
            "🔴 Manglik Details:",
            manglikDetails
          );

          console.log(
            "🔴 Manglik Description:",
            manglikDetails?.data?.description
          );

          // ============================================
          // KALSARPA DETAILS
          // ============================================

          const kalsarpaDetails = parseJsonDetails(
            api.response?.kalsarpa_Details,
            "Kalsarpa Details"
          );

          console.log(
            "🐍 Kalsarpa Details:",
            kalsarpaDetails
          );

          console.log(
            "🐍 Kalsarpa Description:",
            kalsarpaDetails?.data?.description
          );

          // ============================================
          // FINAL CHART DATA
          // ============================================

          const finalChartData = {
            ...api.response,

            planet_Position: planetPosition,

            manglik_Details: manglikDetails,

            kalsarpa_Details: kalsarpaDetails
          };

          console.log(
            "✅ FINAL CHART DATA:",
            finalChartData
          );

          console.log(
            "🔴 FINAL MANGLIK DESCRIPTION:",
            finalChartData?.manglik_Details?.data?.description
          );

          console.log(
            "🐍 FINAL KALSARPA DESCRIPTION:",
            finalChartData?.kalsarpa_Details?.data?.description
          );

          // ============================================
          // SET CHART DATA
          // ============================================

          setChartData(finalChartData);

          // ============================================
          // API SUCCESS MESSAGE
          // ============================================

          if (api.message) {
            showToast(api.message);
          }
        } else {
          showToastFailed(
            api.message ||
            api.errorMessage ||
            "Birth chart generation failed."
          );
        }
      })
      .catch((error) => {
        console.error(
          "❌ Birth Chart API Error:",
          error
        );



        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.errorMessage ||
          error?.response?.data?.title ||
          "Birth chart generation failed.";

        showToastFailed(backendMessage);
      });
  }
  const getPlanetsForRasi = (rasiId) => {
    if (!chartData) return [];

    const planetList = chartData?.planet_Position?.data?.planet_position || [];

    if (!Array.isArray(planetList)) return [];

    return planetList.filter(
      (planet) => Number(planet?.rasi?.id) === Number(rasiId)
    );
  };


  function saveViewedListAPICall() {

    console.log("login user:", loginVal.user_Id);
    console.log("opponent user:", userId);
    axios.get(
      ApiConfig.getUrl("User/saveViewedList"),


      {
        params: {
          userId: loginVal.user_Id, viewedListId: 0, opponentId: userId, type: 0
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` // Standard Bearer format
        }
      }
    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);

        if (api.statusCode == 200) {



        }

        // } else {
        //   showToastFailed(api.errorMessage);
        // }

      })
      .catch(error => {
        // showToastFailed(error);
        // console.error("Error:", error);
      });
  }



  function viewPhoneNumberAPICall() {

    axios.post(
      ApiConfig.getUrl("User/get_user_mobile_number"),
      {
        userId: loginVal.user_Id,
        opponentId: userId
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);

        if (api.statusCode == 200) {
          setViewedMobile(api.response.phone);
          setShowMobilePopup(true);

          showToast(api.response.message);

        } else {

          setViewedMobile();
          showToastFailed(api.response.message);
        }
      })
      .catch(error => {

        setViewedMobile([]);
        if (error.response?.status === 401) {
          toast.error("Session expired. Please login again.");
          localStorage.clear();
          navigation("/login");
        } else {
          showToastFailed("Error fetching mobile number");
        }

      });
  }

  function logoutAPICall() {

    setIsLoading(true);

    axios.post(
      ApiConfig.getUrl("User/logout"),
      {
        user_Id: loginVal.user_Id
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then((response) => {

        const api = ApiResponse.fromJson(response.data);

        setIsLoading(false);

        if (api.status && api.statusCode === 200) {

          showToast("Logout successful.");


          setTimeout(() => {
            localStorage.clear();
            navigation("/login", { replace: true });
          }, 1000);

        } else {
          showToastFailed(api.errorMessage || "Logout failed");
        }

      })
      .catch((error) => {

        setIsLoading(false);

        if (error.response?.status === 401) {
          localStorage.clear();
          navigation("/login", { replace: true });
          return;
        }

        console.error(error);
        showToastFailed("Logout failed");
      });
  }



  // function viewPhoneNumberAPICall() {
  //   setIsLoading(true);
  //   axios.post(
  //     ApiConfig.getUrl("User/get_user_mobile_number"),
  //     {

  //         userId: loginVal.user_Id,
  //         opponentId: userId
  //       ,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`
  //       }
  //     }
  //   )
  //     .then(async response => {
  //       const api = ApiResponse.fromJson(response.data);
  //       if (api.statusCode == 200) {
  //         let number = api.response.mobileNumber;
  //         try {
  //           number = await ApiConfig.decrypt(number);
  //         } catch (e) { console.error("Decryption failed", e); }
  //         setViewedMobile(number);
  //         setShowMobilePopup(true);
  //       } else {
  //         showToastFailed(api.errorMessage || "Failed to fetch number");
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch(error => {
  //       setIsLoading(false);
  //       showToastFailed("Error fetching mobile number");
  //     });
  // }

  function blockUserAPICall(userId, type) {
    setIsLoading(true);
    const blockRequest = {
      user_Id: loginVal.user_Id,
      block_Id: userId
    };
    axios.post(
      ApiConfig.getUrl("User/user_block"),
      JSON.stringify(blockRequest),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }

    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);
        if (api.statusCode == 200) {
          setIsLoading(false);

          getProfileAPICall()

          showToast("Blocked Sent Successfully!");

        } else {
          setIsLoading(false);
        }

      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed("Interest Sent fail!");
      });
  }


  function sendInterestAPICall(senderId, opponentId, type) {
    setIsLoading(true);
    axios.get(
      ApiConfig.getUrl("User/sendPartnerRequest"),
      {
        params: {
          userId: loginVal.user_Id, viewedListId: 0, opponentId: opponentId, type: type
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);

        if (api.statusCode === 200) {
          setIsLoading(false);
          getProfileAPICall();

          switch (type) {
            case 0:
              showToast("Interest sent successfully!");
              break;

            case -1:
              showToast("Interest removed successfully!");
              break;

            case 1:
              showToast("Interest accepted successfully!");
              break;

            case 2:
              showToast("Interest declined successfully!");
              break;

            default:
              showToast(api.message || "Interest updated successfully!");
          }

        } else {
          setIsLoading(false);
          showToastFailed(api.errorMessage);
        }
      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed("Interest update failed!");
      });
  }

  const interestType =
    profile.type === "" || profile.type === null
      ? null
      : Number(profile.type);

  //console.log("Type"+profile.type)


  function sendChatRequestAPIcall(userId, opponentId, requestType) {
    setIsLoading(true);
    axios.get(
      ApiConfig.getUrl("User/sendChatRequest"),
      {
        params: {
          user_Id: userId, opponent_Id: opponentId, requestType: requestType, LoggedInUser_Id: loginVal.user_Id
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);
        if (api.statusCode == 200 && api.status == true) {

          setIsLoading(false);
          if (requestType == 0) {
            setUsers(prev =>
              prev.map((user, t) =>
                t === requestType ? { ...user, is_ChatRequest: true } : user
              )
            );
          }
          setUsers(prev =>
            prev.map((user, i) =>
              i === requestType ? { ...user, requestType: requestType } : user
            )
          );

          // showToast("Chat Request Sent Successfully!");
          getProfileAPICall();

        } else {
          showToastFailed(api.errorMessage);

          setIsLoading(false);
        }

      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed("Chat Request Sent fail!");
      });
  }



  function saveShortListAPICall(opponentId, type) {
    setIsLoading(true);

    axios.get(ApiConfig.getUrl("User/shortList"), {
      params: {
        userId: loginVal.user_Id,
        viewedListId: 0,
        opponentId: opponentId,
        type: type
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
        const api = ApiResponse.fromJson(response.data);

        if (api.statusCode === 200) {
          setIsLoading(false);

          SetProfile(prev => ({
            ...prev,
            is_Shortlist: !prev.is_Shortlist
          }));

          if (type === 0) {
            showToast("Shortlisted Successfully!");
          } else if (type === 1) {
            showToast("Removed from Shortlist Successfully!");
          }

        } else {
          setIsLoading(false);
          showToastFailed(api.errorMessage);
        }
      })
      .catch(error => {
        setIsLoading(false);
        console.error(error);
        showToastFailed("Shortlist failed!");
      });
  }


  function clientdata(label, value, type) {
    const fieldValue = value?.replace(/^:\s*/, "").trim();

    return (
      <div>
        <div className="row">
          <div
            style={{
              width: "50%",
              fontFamily: "Inter-Regular",
            }}
          >
            <label>{label}</label>
          </div>

          <div
            style={{
              width: "50%",
              fontWeight: "bold",
            }}
          >
            {fieldValue ? (
              <label>{value}</label>
            ) : requestedFields[type] ? (
              <span
                style={{
                  color: "green",
                  textDecoration: "none"
                }}
              >
                : {label}  Request Sent
              </span>
            )
              : (
                <div
                  onClick={() => sendProfileRequest(type)}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    cursor: "pointer",

                    // IMPORTANT
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      color: "darkorange",
                      cursor: "pointer",
                      flexShrink: 0,
                      textDecoration: "none"
                    }}
                  >
                    :
                  </span>

                  <span
                    style={{
                      color: "darkorange",
                      paddingLeft: "8px",
                      cursor: "pointer",
                      pointerEvents: "none",
                      textDecoration: "none"
                    }}
                  >
                    Request For {label}
                  </span>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
  function clicktoViewpage() {
    navigation('/Viewpage')
  }

  function clickInterestPage() {
    navigation('/Interestpage')
  }
  function clickSearchPage() {
    navigation('/Searchpage')
  }
  function clickHomeListPage() {
    navigation('/HomeList')
  }


  function sendProfileRequest(type) {

    setIsLoading(true);
    const request = {
      userId: loginVal.user_Id,
      opponentId: profile.userid,
      type: type,
    };

    axios.post(
      ApiConfig.getUrl("User/sendProfileRequest"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }

    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);
        if (api.statusCode == 200) {
          setIsLoading(false);
          setRequestedFields((prev) => ({
            ...prev,
            [type]: true,
          }));

          getProfileAPICall()

          showToast(api.response.message);

        } else {
          setIsLoading(false);
          showToast(api.response.message);
        }

      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed("Request Failed.");
      });
  }

  const handleBirthChartPayment = async () => {
    console.log("🔥 Birth Chart Payment Started");

    if (!window.Razorpay) {
      toast.error("Razorpay SDK not loaded");
      return;
    }

    if (!token) {
      toast.error("Please login again");
      navigation("/login");
      return;
    }

    if (!loginVal?.user_Id) {
      toast.error("User information missing");
      return;
    }

    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      // =========================================
      // 1. CREATE RAZORPAY ORDER
      // =========================================

      const orderResponse = await axios.post(
        ApiConfig.getUrl("api/Razorpay/create-order"),
        {
          user_Id: Number(loginVal.user_Id),
          amount: 10,
          planId: 11
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log(
        "🔥 Create Order Response:",
        orderResponse.data
      );

      const orderData = ApiResponse.fromJson(
        orderResponse.data
      );

      if (
        orderData.statusCode !== 200 ||
        !orderData.response?.id
      ) {
        toast.error(
          orderData.message ||
          orderData.errorMessage ||
          "Failed to create Razorpay order"
        );

        setIsLoading(false);
        return;
      }

      const orderDetails = orderData.response;

      console.log(
        "✅ Razorpay Order:",
        orderDetails
      );

      // =========================================
      // 2. RAZORPAY OPTIONS
      // =========================================

      const options = {
        key: "rzp_test_TTa99SB88bTpGe",

        amount: orderDetails.amount,

        currency: orderDetails.currency || "INR",

        name: "IndiaMetti",

        description: "Birth Chart - ₹10",

        order_id: orderDetails.id,

        prefill: {
          name: loginVal?.user_Name || "",
          email: loginVal?.email_Id || "",
          contact: loginVal?.mobile_number || ""
        },

        theme: {
          color: "#ff8c00"
        },

        // =========================================
        // 3. PAYMENT SUCCESS
        // =========================================

        handler: async function (paymentResponse) {
          console.log(
            "✅ Razorpay Payment Success:",
            paymentResponse
          );

          try {
            // =====================================
            // 4. VERIFY PAYMENT
            // =====================================

            const verifyResponse = await axios.post(
              ApiConfig.getUrl(
                "api/Razorpay/payment-success"
              ),
              {
                user_Id: Number(loginVal.user_Id),

                paymentId:
                  paymentResponse.razorpay_payment_id,

                order_id:
                  paymentResponse.razorpay_order_id,

                amount: orderDetails.amount,
                entity: "order",
                currency:
                  orderDetails.currency || "INR",

                status: "captured",

                planId: 11,

                description: "Birth Chart - ₹10"
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`
                }
              }
            );

            console.log(
              "🔥 Payment Verification Response:",
              verifyResponse.data
            );

            const verifyData = ApiResponse.fromJson(
              verifyResponse.data
            );

            // =====================================
            // 5. PAYMENT VERIFIED
            // =====================================

            if (
              verifyData.statusCode === 200 &&
              verifyData.status === true
            ) {
              toast.success(
                "Payment Successful! Generating Birth Chart..."
              );

              console.log("🔥 Payment verified successfully");

              // Payment success state
              localStorage.setItem("isPaidForAstrology", "true");
              setIsAstrologyPaidcheck(true);
              await checkLimitAndGenerateChart();

              // Generate chart
              // generateBirthChart();
            } else {
              toast.error(
                verifyData.errorMessage ||
                verifyData.message ||
                "Payment verification failed"
              );
            }

          } catch (error) {
            console.error(
              "❌ Payment Verification Error:",
              error
            );

            toast.error(
              error?.response?.data?.errorMessage ||
              error?.response?.data?.message ||
              "Payment verification failed"
            );

          } finally {
            setIsLoading(false);
          }
        },

        // =========================================
        // 7. PAYMENT CANCEL
        // =========================================

        modal: {
          ondismiss: function () {
            console.log(
              "⚠️ Razorpay payment cancelled"
            );

            toast.info("Payment cancelled");

            setIsLoading(false);
          }
        }
      };

      // =========================================
      // 8. OPEN RAZORPAY
      // =========================================

      const rzp = new window.Razorpay(options);

      rzp.on(
        "payment.failed",
        function (error) {
          console.error(
            "❌ Razorpay Payment Failed:",
            error
          );

          toast.error(
            error?.error?.description ||
            "Payment Failed"
          );

          setIsLoading(false);
        }
      );

      rzp.open();

    } catch (error) {
      // =========================================
      // CREATE ORDER ERROR
      // =========================================

      console.error(
        "❌ Create Order / Payment Error:",
        error
      );

      toast.error(
        error?.response?.data?.errorMessage ||
        error?.response?.data?.message ||
        "Unable to process payment"
      );

      setIsLoading(false);
    }
  };


  const hasProfileImage =
    profile.profileImages?.some(
      img => img.profilePath && img.profilePath.trim() !== ""
    );

  const disableRightClick = (e) => {
    if (ApiConfig.ENV == "PRD") {
      e.preventDefault();
    }
  };

  console.log("theme colortext:" + profile.themeColourNumber);



  return (
    <>
      <ToastContainer />
      <div className="fullview" onContextMenu={disableRightClick} >
        {isLoading && (
          <div className="loader-overlay">
            <Oval
              height={60}
              width={60}
              color="#ffffff"
              secondaryColor="#cccccc"
              strokeWidth={4}
              visible={true}
            />
          </div>
        )}

        <div className="top-bar" >
          <div className="container">
            <ul>
              {/* <li>Home</li>
                   <li>Matches</li> */}
              <img src={logo} alt='logo' style={{ width: '50px' }} />
              <li onClick={clicktoViewpage} className='m-2 p-1'>
                <i className="bi bi-people d-inline m-1"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">All matches</span>
              </li>
              <li className="m-2 p-1" onClick={clickHomeListPage}>
                <i className="bi bi-house d-inline m-1"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">Home</span>
              </li>

              <li onClick={clickInterestPage} className='m-1 p-1'>
                <i className="bi bi-heart d-inline m-2"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">Interests</span>

              </li>
              <li onClick={clickSearchPage} className='m-1 p-1'><i className="bi bi-search d-inline m-2"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">Search</span></li>
              <li onClick={() => setShowNotif(true)} className='m-2 p-1' >
                <i className="bi bi-bell d-inline m-2"></i>
                <span className="d-none d-sm-inline  text-decoration-none text-dark">Notification</span>
              </li>
              <Notification
                show={showNotif}
                onClose={() => setShowNotif(false)}
              />
              {/* <button className='top-button'>Switch account</button> */}
              <div style={{ position: "relative", display: "inline-block" }}>
                <img style={{ width: "40px", height: "40px", borderRadius: "50% " }}
                  src={savedImage || default_avatar}
                  onClick={() => setShowMenu(!showMenu)}
                />
                {showMenu && (
                  <div className="dropdown-menu show" style={{ position: "absolute", right: "5px" }}>
                    <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickEditprofile}>Edit Profile</div>
                    {/* <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickUpgradeplans}>Upgrade Plan</div> */}
                    <div className="dropdown-item " style={{ cursor: "pointer" }} onClick={clickSettingspage}>Settings</div>
                    {/* {showsubMenu && (
                                 <div className="dropdown-item" style={{ cursor: "pointer", textAlign: "center",backgroundColor:"darkorange",color:"white"}}>Block List</div>
                                 )} */}
                    <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickLogin}>Logout</div>
                  </div>
                )}
              </div>
              {/* <button className='top-button'>Settings</button> */}
            </ul>
          </div>
          <div style={{ position: "relative", display: "inline-block" }}>


          </div>

        </div>

        <div className="container register-column p-4" onClick={() => setShowMenu(false)}>

          <div className='client-list' style={{ marginTop: '100px' }}>


            <div className='card shadow-sm row gx-0' style={{
              background: profile.themeColour || localStorage.getItem("themeColor"),
              color: profile.themeColourText || localStorage.getItem("themeColourText") || "#0f0b0b",
              borderRadius: "10px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
            }}>
              <div
                className="col-lg-3 col-sm-12 d-flex align-items-start"
                style={{ position: "relative" }}
              >
                {(profile.isPaid === true || profile.is_Paid === true) && (
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      zIndex: 10,
                      backgroundColor: "#FFD700",
                      color: "#000",
                      padding: "2px 5px",
                      borderRadius: "20px",
                      fontSize: "10px",
                      fontWeight: "bold",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                    }}
                  >
                    ⭐ {profile.lookUpId || "Premium"} Member
                  </div>
                )}

                <Carousel interval={5000} className="w-100">

                  {hasProfileImage ? (

                    profile.profileImages
                      .filter(img => img.profilePath && img.profilePath.trim() !== "")
                      .map((img, index) => (
                        <Carousel.Item key={index}>
                          <img
                            className="profile-carousel-img w-100"
                            src={img.profilePath}
                            alt="Profile"
                            style={{
                              objectFit: "fill",
                              borderRadius: "10px",
                              height: "300px",
                              filter: profile.isBlurred ? "blur(12px)" : "none"
                            }}
                          />
                        </Carousel.Item>
                      ))

                  ) : (

                    <Carousel.Item>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "300px",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          sendProfileRequest(38);
                        }}
                      >
                        <img
                          className="profile-carousel-img w-100"
                          src={default_avatar}
                          alt="Default Profile"
                          style={{
                            objectFit: "fill",
                            borderRadius: "10px",
                            height: "300px",
                            width: "100%"
                          }}
                        />

                        <button
                          className="ms-5"
                          type="button"
                          style={{
                            width: "200px",
                            cursor: "pointer",
                            backgroundColor: "white",
                            color: "darkorange",
                            border: "1px solid darkorange",
                            borderRadius: "6px",
                            padding: "2px",
                            fontWeight: "bold",
                            position: "absolute",
                            bottom: "10px",
                            left: "0",
                            zIndex: 5
                          }}
                        >
                          {requestedFields[38]
                            ? "Request Sent"
                            : "Request For Profile Image"}
                        </button>
                      </div>
                    </Carousel.Item>

                  )}

                </Carousel>
              </div>

              <div className='col-lg-9 col-sm-12 ps-lg-4'>
                <div className="d-flex justify-content-end">
                  {(profile.isBlocked) && (
                    <button
                      className='send-button'
                      onClick={(e) => {
                        blockUserAPICall(userId, 0);
                      }}

                    >
                      UnBlock
                    </button>
                  )}
                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <div><label className="name" style={{
                    backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",


                  }}><b>{profile.first_Name ?? ""}</b></label></div>
                  <div className="d-flex justify-content-end align-items-center gap-3">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>



                      {/* <div
                        title="Chat"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigation('/ChatInitiate', { state: { opponentId: userId ,opponentName:profile.first_Name} })}
                      >
                        <i className="bi bi-chat-dots fs-4" style={{ color: "darkorange" }}></i>
                      </div> */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          saveShortListAPICall(
                            profile.userid,
                            profile.is_Shortlist ? 1 : 0);
                        }} >
                        <img
                          className="shortlist-logo"
                          src={profile.is_Shortlist ? shortlist : notShortlist}
                          alt="shortlist"
                        />
                      </div>



                    </div>
                    <div>
                      <button
                        className="btn p-0 w-75"
                        onClick={() => setOpenMenu(!openMenu)}
                      >
                        <i className="bi bi-three-dots-vertical fs-5"></i>
                      </button>

                      {openMenu && (
                        <div
                          className="dropdown-menu show"
                          style={{ position: "absolute", right: 0, marginTop: "5px" }}
                        >

                          <button className="dropdown-item" onClick={() => {
                            setShowPopup(true);
                            setOpenMenu(false);
                          }}>
                            <i className="bi bi-slash-circle me-2"></i>
                            Block Profile
                          </button>

                          <button
                            className="dropdown-item"
                            onClick={() => {

                              setOpenReport(true);
                              setOpenMenu(false);
                            }}
                          >
                            <i className="bi bi-flag me-2"></i>
                            Report Profile
                          </button>

                        </div>
                      )}


                      <Report

                        show={openReport}
                        onClose={() => setOpenReport(false)}
                        userId={userId}
                      />
                    </div>
                  </div>

                </div>

                <div
                  style={{
                    backgroundImage: profile?.themeColourNumber || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }}
                >
                  IMIT{profile?.userNum}
                </div>

                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  margin: "0", textDecoration: "none",
                  listStyleType: "none"
                }}>

                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                    listStyleType: 'none',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span>{profile.age} yrs
                  </li>

                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10,
                    display: 'flex',
                    alignItems: 'center',
                    color: profile.themeColourText,
                    backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.height} CM
                  </li>
                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10,
                    display: 'flex',
                    alignItems: 'center',
                    color: profile.themeColourText,
                    backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.caste}
                  </li>


                </ul>

                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  margin: "0",
                  color: profile.themeColourText,
                }}>


                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.religion}
                  </li>
                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.education_in_Detail}
                  </li>

                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.occupation}
                  </li>


                </ul>

                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  color: profile.themeColourText,
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  listStylePosition: "inside",
                  margin: "0",
                }}>


                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.district}
                  </li>

                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.state}
                  </li>
                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> {profile.country}.
                  </li>
                </ul>
                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  listStylePosition: "inside",
                  margin: "0",
                  color: profile.themeColourText,
                }}>


                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                    display: 'flex', alignItems: 'center', backgroundImage: profile?.themeColourText || "linear-gradient(45deg, #161113, #161518)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    display: "inline-block",
                    fontWeight: "bold"
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none',
                      color: 'rgb(255, 123, 0)',
                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                    }}>•</span> Contact :
                    <span className="ms-1" style={{
                      color: "darkorange",
                      textDecoration: "none"
                    }}>   Get contact via Chat.</span>
                    {/* {loginVal.is_Paid === true || loginVal.isPaid === true ? (
                      <button
                        className="send-button ms-3 bg-primary"
                        onClick={viewPhoneNumberAPICall}
                      >
                        View Phone Number
                      </button>
                    ) : (
                      <button
                        className="send-button ms-3"
                        onClick={clicktoUpgradePage}
                      >
                        Upgrade to View
                      </button>
                    )} */}
                  </li>


                </ul>

                <div className="mt-3">

                  {interestType === null && (
                    <button
                      className="send-button"
                      onClick={() =>
                        sendInterestAPICall(loginVal.user_Id, userId, 0)
                      }
                    >
                      Send Interest
                    </button>
                  )}

                  {interestType === 0 && profile.is_Interestlist === true && (
                    <button
                      className="send-button"
                      onClick={() =>
                        sendInterestAPICall(loginVal.user_Id, userId, -1)
                      }
                    >
                      Remove Interest
                    </button>
                  )}

                  {interestType === 0 && profile.is_Interestlist === false && (
                    <>
                      <button
                        className="send-button"
                        onClick={() =>
                          sendInterestAPICall(userId, loginVal.user_Id, 1)
                        }
                      >
                        Accept Interest
                      </button>

                      <button
                        className="send-button"
                        onClick={() =>
                          sendInterestAPICall(userId, loginVal.user_Id, 2)
                        }
                      >
                        Decline
                      </button>
                    </>
                  )}

                  {interestType === 1 && (
                    <label style={{ color: "green" }}>
                      <b>Your request is accepted.</b>
                    </label>
                  )}

                  {interestType === 2 && (
                    <label style={{ color: "red" }}>
                      <b>Your request is declined.</b>
                    </label>
                  )}

                </div>

                <div className="me-3 mt-2 mb-1">

                  {(profile.type == 1) && (profile.requestType == 0) && (profile.is_ChatRequest == true) && (
                    <button
                      className='send-button' style={{ fontSize: "12px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        sendChatRequestAPIcall(loginVal.user_Id, profile.userid, -1);
                      }}>
                      Remove Chat Interest
                    </button>
                  )}


                  {(profile.type == 1) && (profile.requestType == null || profile.requestType == -1) && (
                    <button
                      className='send-button' style={{ fontSize: "12px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        sendChatRequestAPIcall(loginVal.user_Id, profile.userid, 0);
                      }}
                    >
                      Send Chat Interest
                    </button>
                  )}


                  {(profile.type == 1) && (profile.requestType == 0) && (profile.is_ChatRequest == false) && (

                    <>
                      <button
                        className='send-button'
                        onClick={(e) => {
                          e.stopPropagation();
                          sendChatRequestAPIcall(profile.userid, loginVal.user_Id, 1);
                        }}
                      >
                        Accept Chat Interest
                      </button>

                      <button
                        className='send-button'
                        onClick={(e) => {
                          e.stopPropagation();
                          sendChatRequestAPIcall(profile.userid, loginVal.user_Id, 2);
                        }}
                      >
                        Decline
                      </button>

                    </>
                  )}


                  {(profile.requestType == 1) && (
                    <div
                      title="Chat"
                      className='ChatMessage'
                      // style={{ cursor: loginVal?.isPaid ? 'pointer' : 'not-allowed' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigation('/ChatInitiate', { state: { opponentId: profile.userid, opponentName: profile.first_Name } })
                      }}
                    >
                      <i className="bi bi-chat-dots fs-3" style={{ color: "darkorange" }}></i>
                    </div>
                  )}
                </div>



                {/* <div><label>IMIT{userId}</label></div>
                <div><label className='normal-text'> {profile.age ?? " "}yrs,{profile.height}', {profile.caste}</label></div>
                <div><label className='normal-text'>{profile.education_in_Detail}, {profile.occupation}</label></div>
                <div><label className='normal-text'>{profile.district},{profile.state}.</label></div>
                <div><label className='normal-text'>{profile.country}.</label></div> */}


                <div className='row'>
                  <div className="col d-flex flex-column flex-md-row gap-2 mt-0">

                    {/* <label className='verify-text normal-text me-3'>

                      <span
                        style={{
                          cursor: "none",
                          textDecoration: "none",
                          color:
                            profile.email_Status == true ? "green" : "red"

                        }}>


                        {
                          profile.email_Status == true ? "Email verified" : "Email Not Verified"}
                      </span>
                    </label> */}
                    <label className='verify-text normal-text  p-1 '
                      style={{
                        backgroundColor: "hsl(90, 42%, 87%)",
                        borderRadius: "6px",
                        width: "200px",
                        height: "30px"
                      }}>
                      <i className="bi bi-phone ps-1 pe-1" style={{ color: "green" }}></i>
                      <span
                        style={{
                          cursor: "none",
                          fontSize: "13px", fontWeight: "bold",
                          textDecoration: "none",
                          color:
                            profile.mobileNumber_Status == true ? "green" : "red"
                        }}>

                        {profile.mobileNumber_Status == true ? "Mobile verified" : "Mobile Not Verified"}
                      </span>
                    </label>
                    {profile.documentStatus === 0 && (

                      <label className='verify-text normal-text  p-1 '
                        style={{
                          backgroundColor: "hsl(90, 42%, 87%)",
                          borderRadius: "6px",
                          width: "200px",
                          height: "30px"
                        }}>
                        <i className="bi bi-file-earmark-check ps-1 pe-1" style={{ color: "green" }}></i>
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "bold",
                            textDecoration: "none",
                            color: "green"
                          }}>
                          {
                            profile.documentStatus === 0 ? "Documents Verified" : "Documents Not Verified"
                          }
                        </span></label>
                    )}
                    {/* {loginVal?.isPaid ? (
                        <button className='bg-primary text-white p-0 px-2' onClick={viewPhoneNumberAPICall}>View </button>
                      ) : (
                        <button className='bg-primary text-white p-0 px-2' onClick={clicktoUpgradePage}>Upgrade</button>
                      )} */}
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="container container_block border ">
            <div className="row ">

              <div className="col col-sm-12" >
                <label className="h4 p-2 gradient-bg fs-5" style={{ backgroundColor: "lightgrey", width: '100%', fontFamily: "Inter-semibold" }}>Personal Information</label>
                {clientdata("Age", ": " + (profile.age ?? ""), 1)}
                {clientdata("Height", ": " + (profile.height ?? ""), 2)}
                {clientdata("Weight", ": " + (profile.weight ?? ""), 3)}
                {clientdata("Body Type", ": " + (profile.body_Type ?? ""), 4)}
                {clientdata("Mother Tongue", ": " + (profile.mother_Tongue ?? ""), 5)}
                {clientdata("Profile Created For", ": " + (profile.created_For ?? ""), 6)}
                {clientdata("Marital Status", ": " + (profile.marital_Status ?? ""), 7)}
                {clientdata("Lives In", ": " + (profile.district ?? ""), 8)}

                {clientdata("Religion", ": " + (profile.religion ?? ""), 9)}
                {clientdata("Caste", ":" + (profile.caste ?? ""), 10)}
                {clientdata("Subcaste", ": " + (profile.sub_Caste ?? ""), 11)}
                {clientdata("Gothra(m)", ": " + (profile.gothram ?? ""), 12)}
                {clientdata("Date Of Birth", ": " + (profile.date_Of_Birth?.split(" ")[0] ?? ""), 13)}
                {clientdata("Star", ": " + (profile.star ?? ""), 14)}
                {clientdata("Raasi", ": " + (profile.raasi ?? ""), 15)}
                {clientdata("Lagna", ": " + (profile.lagna ?? ""), 37)}
                {/* {clientdata("Horoscope", ": " + (profile.horoscope ?? ""), 16)} */}
                {clientdata("Employment", ": " + (profile.employed_In ?? ""), 17)}
                {clientdata("Education", ": " + (profile.education_in_Detail ?? ""), 18)}
                {clientdata("Occupation", ": " + (profile.occupation ?? ""), 19)}
                {clientdata("Income Details", ": " + (profile.from_Income ?? ""), 20)}

                <label className="h4 p-2 gradient-bg fs-5" style={{ backgroundColor: "lightgrey", width: '100%', fontFamily: "Inter-semibold" }}>Family Information</label>
                {clientdata("Family Values", ": " + (profile.family_Values ?? ""), 21)}
                {clientdata("Family Type", ": " + (profile.family_Type ?? ""), 22)}
                {clientdata("Family Status", ": " + (profile.family_Status ?? ""), 23)}

                {clientdata("Father's Occupation", ": " + (profile.father_Occupation ?? ""), 24)}
                {clientdata("Mother's Occupation", ": " + (profile.mother_Occupation ?? ""), 25)}
                {clientdata("No of Brother(s)", ": " + (profile.no_Of_Brothers ?? ""), 26)}
                {clientdata("No of Brother(s) Married", ":" + (profile.brothers_Married ?? ""), 27)}
                {clientdata("No of Sister(s)", ": " + (profile.no_Of_Sister ?? ""), 28)}
                {clientdata("No of Sister(s) Married", ":" + (profile.siters_Married ?? ""), 29)}
                {clientdata("Family Location ", ": " + (profile.district ?? ""), 30)}
                {gender === "Female" &&
                  clientdata(
                    "living Preference ",
                    ": " + (profile.living_Preference ?? ""),
                    39
                  )
                }
                {clientdata("Ancestral Origin", ": " + (profile.ancestral_Origin ?? ""), 31)}

                <label className="h4 p-2 gradient-bg fs-5" style={{ backgroundColor: "lightgrey", width: '100%', fontFamily: "Inter-semibold" }}>Contact Information</label>
                {clientdata("Mobile Number", ": Get contact via Chat. ")}


                {/* <div className="p-2 d-flex align-items-center">
                  
                  {loginVal?.is_Paid === true ? (
                    <button
                      className="send-button ms-3 bg-primary"
                      onClick={viewPhoneNumberAPICall}
                    >
                      View Phone Number
                    </button>
                  ) : (
                    <button
                      className="send-button ms-3"
                      onClick={clicktoUpgradePage}
                    >
                      Upgrade to View
                    </button>
                  )}
                </div> */}

                <label className="h4 p-2 gradient-bg fs-5" style={{ backgroundColor: "lightgrey", width: '100%', fontFamily: "Inter-semibold" }}> About {profile.first_Name ?? ""}</label>

                <p> {(profile.first_Name ?? "")} is a software Engineer.. currently working in {(profile.employed_In ?? "")} in {(profile.lives_In ?? "")}.</p>
                <label className="h4 p-2 gradient-bg fs-5" style={{ backgroundColor: "lightgrey", width: '100%', fontFamily: "Inter-semibold" }}>Lifestyle</label>
                {clientdata("Eating Habits", ": " + (profile.eating_Habit ?? "Add Eating Habbit"), 34)}
                {clientdata("Smoking Habits", ": " + (profile.smoking_Habit ?? ""), 35)}
                {clientdata("Drinking Habits", ": " + (profile.drinking_Habit ?? ""), 36)}
              </div>
              <div>
                <label
                  className="h4 p-2 gradient-bg fs-5"
                  style={{
                    backgroundColor: "lightgrey",
                    width: "100%",
                    fontFamily: "Inter-semibold",
                  }}
                >
                  ✨ Birthchart
                </label>

                {/* PAY ₹10 BUTTON
                {!isAstrologyPaidcheck ? (
                  <div className="text-center mt-4 mb-3">
                    <button
                      type="button"
                      style={{ backgroundColor: "darkorange" }}
                      className="btn btn-primary px-4 py-2 w-100"
                      onClick={handleBirthChartPayment}
                    >
                      Generate Birth Chart - Pay ₹10
                    </button>

                    <p className="text-muted mt-2 mb-0" style={{ fontSize: "13px" }}>
                      Pay ₹10 to view your complete birth chart
                    </p>
                  </div>
                ) : ( */}
                <>
                  {!chartData && (
                    <div className="text-center mt-4 mb-3">
                      <button
                        type="button"
                        className="btn px-4 py-2 w-100 text-dark" style={{ border: "solid orange" }}
                        onClick={generateBirthChart}
                      >
                        View Birth Chart
                      </button>
                    </div>
                  )}
                  {/* BIRTH CHART RESULT - PAYMENT SUCCESS பிறகு */}
                  {chartData && (
                    <div className="birth-result-card mt-4">


                      {/* RAASI / STAR / LAGNA */}
                      <div className="birth-info text-center">
                        <b>Raasi: </b> {chartData?.raasi_En} ,
                        <b>Star:</b> {chartData?.star_En} ,
                        <b>Lagna:</b>  {chartData?.lagna_En}
                      </div>
                      <div className="birth-info text-center">
                        <b>Manglik Dosha:</b>{" "}
                        {chartData?.has_Manglik_Dosha ? "Yes" : "No"}

                        <br />

                        <b>Kalsarpa Dosha:</b>{" "}
                        {chartData?.has_Kalsarpa_Dosha ? "Yes" : "No"}

                        <br />

                        <b>Manglik Details:</b>{" "}
                        {chartData?.manglik_Details?.data?.description || "No details available"}

                        <br />

                        <b>Kalsarpa Details:</b>{" "}
                        {chartData?.kalsarpa_Details?.data?.description || "No details available"}
                      </div>


                      {/* RASI CHART */}
                      <div className="text-center mt-5">
                        <div className="south-chart-grid">
                          {rasiList.map((rasi, index) => {

                            if (rasi.id === "center") {
                              return (
                                <div key={index} className="chart-center-box">
                                  <div className="center-title">Raasi</div>
                                </div>
                              );
                            }

                            const planets = getPlanetsForRasi(rasi.id);

                            const rasiName =
                              planets.length > 0
                                ? getLanguageName(planets[0]?.rasi)
                                : rasi.name;

                            return (
                              <div key={index} className="chart-box">

                                <div className="rasi-name">
                                  {rasiName}
                                </div>

                                <div className="planets-content">
                                  {planets.map((planet, pIndex) => {
                                    const planetName = getLanguageName(planet);

                                    return (
                                      <div key={pIndex} className="planet-badge">
                                        {planetName}
                                      </div>
                                    );
                                  })}
                                </div>

                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* PLANET POSITION TABLE */}
                      <div className="mt-5">
                        <h5 className="mb-3">Planet Positions</h5>

                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Planet</th>
                                <th>Rasi</th>
                                <th>Degree</th>
                                <th>Retrograde</th>
                              </tr>
                            </thead>

                            <tbody>
                              {(
                                chartData?.planet_Position?.data?.planet_position ||
                                chartData?.planet_Position?.planet_position ||
                                chartData?.data?.planet_position ||
                                []
                              ).map((planet, index) => (
                                <tr key={index}>
                                  <td>
                                    {planet?.name_en ||
                                      planet?.name ||
                                      "-"}
                                  </td>

                                  <td>
                                    {planet?.rasi?.name_en ||
                                      planet?.rasi?.name ||
                                      "-"}
                                  </td>

                                  <td>
                                    {planet?.degree !== undefined &&
                                      planet?.degree !== null
                                      ? Number(planet.degree).toFixed(2)
                                      : "-"}
                                  </td>

                                  <td>
                                    {planet?.is_retrograde ? "Yes" : "No"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                  )}
                </>
                {/* )} */}
              </div>
            </div>
          </div>
        </div>
        <div>
          {showPopup && <PopupBlock onClose={click} />}
        </div>
        <Popup show={showMobilePopup} onClose={() => setShowMobilePopup(false)}>
          <div className="p-4 text-center">
            <h4>Contact Details</h4>
            <hr />
            <p className="fs-5">Mobile Number: <strong>{viewedMobile}</strong></p>
            <button className="btn btn-secondary mt-3" onClick={() => setShowMobilePopup(false)}>Close</button>
          </div>
        </Popup>
      </div >

      <footer className='bg-dark text-white text-center'>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>
  );
}
export default Customerdetails;